import i18next from "i18next";
import { initReactI18next } from "react-i18next";

import translations_en from "./en.json";
import translations_fi from "./fi.json";


const resources = {
  en: {
    translation: translations_en,
  },
  fi: {
    translation: translations_fi,
  },
};

i18next.use(initReactI18next).init({
  resources,
  lng: "fi"
});

export default i18next;
